import {SignalEventConfiguration, SignalsEventConfiguration, SignalType} from 'gabi-api-ts/v2/common/signals/signals';
import {getI18n} from 'react-i18next';

import {SignalDefinitions} from '@/model/signal-definitions/signal-definition';

const getSignalTypeLabel = (signalType: SignalType) => {
    switch(signalType) {
    case SignalType.Signal_PR: return getI18n().t('signalType.pulseRate');
    case SignalType.Signal_RR: return getI18n().t('signalType.respiratoryRate');
    case SignalType.Signal_SPO2: return getI18n().t('signalType.spo2');
    case SignalType.Signal_Actigraphy: return getI18n().t('signalType.movements');
    case SignalType.Signal_BP_SYS: return getI18n().t('signalType.bloodPressureSystolic');
    case SignalType.Signal_BP_DIA: return getI18n().t('signalType.bloodPressureDiastolic');
    case SignalType.NEWS2: return getI18n().t('signalType.news2');
    default:
        return 'Unknown';
    }
};
const getSignalTypeDualLabel = (signalType: SignalType) => {
    switch(signalType) {
    case SignalType.Signal_PR: return getI18n().t('signalType.pulseRate');
    case SignalType.Signal_RR: return getI18n().t('signalType.respiratoryRate');
    case SignalType.Signal_SPO2: return getI18n().t('signalType.spo2');
    case SignalType.Signal_Actigraphy: return getI18n().t('signalType.movements');
    case SignalType.Signal_BP_SYS: return getI18n().t('signalType.bloodPressure');
    case SignalType.Signal_BP_DIA: return getI18n().t('signalType.bloodPressure');
    case SignalType.NEWS2: return getI18n().t('signalType.news2');
    default:
        return 'Unknown';
    }
};

const getSignalTypeUnit = (signalType: SignalType) => {
    return (SignalDefinitions[signalType] ?? SignalDefinitions[-1]).unit;
};

const getSignalTypeIdentifier = (signalType: SignalType) => {
    switch(signalType) {
    case SignalType.Signal_PR: return 'pulseRate';
    case SignalType.Signal_RR: return 'respiratoryRate';
    case SignalType.Signal_SPO2: return 'spo2';
    case SignalType.Signal_Actigraphy: return 'movements';
    case SignalType.Signal_BP_SYS: return 'bloodPressureSystolic';
    case SignalType.Signal_BP_DIA: return 'bloodPressureDiastolic';
    case SignalType.NEWS2: return 'news2';
    // default:
    //     return 'unknown';
    }
};

function getSignalEventConfig(eventConfig: SignalsEventConfiguration, signalType: SignalType): SignalEventConfiguration {
    switch (signalType) {
    case SignalType.Signal_PR: return eventConfig.hr!;
    case SignalType.Signal_RR: return eventConfig.rr!;
    case SignalType.Signal_SPO2: return eventConfig.spo2!;
    default: {
        console.debug(`getSpecificSignalEventConfig(): wrong signal provided ${SignalType[signalType]}. Falling back to pulse rate.`);
        return eventConfig.hr!;
    }
    }
}

export {
    getSignalEventConfig,
    getSignalTypeIdentifier,
    getSignalTypeLabel,
    getSignalTypeDualLabel,
    getSignalTypeUnit,
};
